import { render } from "./ProductNavBar.vue?vue&type=template&id=3f0f146a&scoped=true&ts=true"
import script from "./ProductNavBar.vue?vue&type=script&lang=ts"
export * from "./ProductNavBar.vue?vue&type=script&lang=ts"

import "./ProductNavBar.vue?vue&type=style&index=0&id=3f0f146a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0f146a"]])

export default __exports__